// The em dash as a RENDERED glyph. tests/no-em-dashes.test.js bans the raw
// character (and its entity/escape forms) from source text, but the glyph
// itself is deliberate UI in a few places: the "no data" placeholder in
// stats tables, the logbook's turn-banner framing, label/value separators.
// Building it from the codepoint keeps those renders while keeping source
// files clean. Import this rather than re-deriving it inline.
export const EM_DASH = String.fromCodePoint(0x2014);
